export default function ResultTeamRow({ team, score, odds }) {
  const hasOdds = odds !== undefined;

  return (
    <div className="ticker-result-card__team-row">
      <span className="ticker-result-card__team-image">
        {team.image && <img src={team.image} alt="" onError={(event) => { event.currentTarget.style.display = "none"; }} />}
      </span>
      <b>{team.name}</b>
      {hasOdds && <span className="ticker-result-card__odds">{odds}</span>}
      <span className="ticker-result-card__score">{score}</span>
    </div>
  );
}
